module.exports = __webpack_public_path__ + "img/alesia-kazantceva-VWcPlbHglYc-unsplash.e172f2c4.jpg";